import { component_tool } from '@/tool'
let { WizModal } = component_tool

let componentName = 'version'

const columns = [
  {
    title: '版本号',
    name: 'version',
    dataIndex: 'version',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '版本类型',
    name: 'type',
    dataIndex: 'type',
    dict: [
      // { code: 0, codeName: '移动课堂Ios' },
      // { code: 1, codeName: '移动课堂Android' },
      { code: 2, codeName: '培训助手' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '更新内容',
    name: 'content',
    dataIndex: 'content',
    tableItem: {}
  },
  {
    title: '更新类型',
    name: 'updateType',
    dataIndex: 'updateType',
    dict: [
      { code: 0, codeName: '普通更新' },
      { code: 1, codeName: '强制更新' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '更新地址',
    name: 'updateUrl',
    dataIndex: 'updateUrl',
    tableItem: {}
  },
  {
    title: '发布时间',
    name: 'releaseTime',
    dataIndex: 'releaseTime',
    tableItem: {}
  }
]

const templateConfig = self => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add'],
          buttons: [{
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/version/management/versionAdd'
              }
            }
          }]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update', 'delete'],
        rowOperateView: [{
          key: 'update',
          custom: true,
          params: { children: '编辑'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/version/management/versionUpd'
            }
          }
        },
        {
          key: 'delete',
          custom: true,
          params: { children: '删除'},
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'delete',
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              WizModal.confirm({
                title: '注意',
                content: '删除后数据不可恢复，您确定要删除选中的版本吗？',
                onOk: () => {
                  callback && callback({ id: record.id })
                },
                onCancel() { }
              })
              return null
            }
          }
        }]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
